<template lang="pug">
div(
    v-html="require(`@/assets/icons/${icon}.svg`)"
    :style="styles"
)
</template>

<script>
export default {
  name: 'SvIcon',

  props: {
    icon: {
      type: String,
      required: true,
    },

    size: {
      type: Number,
      default: 0,
    },

    width: {
      type: Number,
      default: 24,
    },

    height: {
      type: Number,
      default: 24,
    },

    fill: {
      type: String,
      default: '',
    },

    stroke: {
      type: String,
      default: '',
    },
  },

  computed: {
    styles() {
      return {
        fill: this.fill,
        stroke: this.stroke,
        height: `${this.height}px`,
        width: `${this.width}px`,
      };
    },
  },
};
</script>
